import React from "react";
import { ComponentType } from "@growth-machine-llc/stridist-api-client";
import { GenericLibraryContextFilter } from "../filters/GenericLibraryContextFilter";

const getCategoryLabel = (category: ComponentType): string => {
  return category
    .split("_")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
};

const ComponentTemplateCategoryLabels = Object.values(ComponentType).reduce(
  (acc, category) => {
    acc[category] = getCategoryLabel(category);
    return acc;
  },
  {} as Record<ComponentType, string>,
);

export const CategoryFilter = React.memo(function CategoryFilter({
  onChange,
  contextFilters,
  className,
}: {
  onChange?: (selected: ComponentType[]) => void;
  contextFilters?: ComponentType[];
  className?: string;
}) {
  return (
    <GenericLibraryContextFilter
      enumType={ComponentType}
      filterTypesLabels={ComponentTemplateCategoryLabels}
      labelType="Type"
      excludeValues={[ComponentType.MESSAGE]}
      noneOptionVisible={false}
      contextFilters={contextFilters}
      onChange={onChange}
      className={className}
    />
  );
});
